import { render, staticRenderFns } from "./OsobeNavigation.vue?vue&type=template&id=64269421&scoped=true&"
import script from "./OsobeNavigation.vue?vue&type=script&lang=js&"
export * from "./OsobeNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64269421",
  null
  
)

export default component.exports